<template>
    <div class="row">
        <div class="col">
            <endpoint-form></endpoint-form>
        </div>
    </div>
</template>

<script>
    import EndpointForm from './endpoint/Form'

    export default {
    
        components: {
            EndpointForm
        }
    }
</script>
